import { Box, Paper } from '@mui/material';
import { useState } from 'react';
import { FORM_ACTION, useDataProvider, useSnackbar } from '@ui-framework/index';
import { useParams } from 'react-router-dom';
import { nanoid } from 'nanoid';
import DefaultSchedulesList from './components/DefaultSchedulesList/index';
import DefaultScheduleForm from './components/DefaultScheduleForm';
import DefaultScheduleDetailView from './components/DefaultScheduleDetailView';

function DefaultSchedules({
  serviceProviderId,
  locationId = null,
  mode = FORM_ACTION.LIST,
}) {
  const snackbar = useSnackbar();

  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { put, get, post, remove, getApiUrl } = useDataProvider(provider);

  const { defaultScheduleId: selectedScheduleId } = useParams();
  const [listRefreshKey, setlistRefreshKey] = useState(nanoid());

  const commonParams = {
    snackbar,
    put,
    get,
    post,
    remove,
    getApiUrl,
    pageId: serviceProviderId,
  };

  const refreshListView = () => {
    setlistRefreshKey(nanoid());
  };

  return (
    <Box>
      {[FORM_ACTION.VIEW].includes(mode) && (
        <Paper variant="outlined" sx={{ mb: 2, mt: 2 }}>
          <DefaultScheduleDetailView
            serviceProviderId={serviceProviderId}
            params={commonParams}
            selectedScheduleId={selectedScheduleId}
            locationId={locationId}
          />
        </Paper>
      )}
      {[FORM_ACTION.EDIT].includes(mode) && (
        <Paper variant="outlined" sx={{ mb: 2, mt: 2 }}>
          <DefaultScheduleForm
            params={commonParams}
            selectedScheduleId={selectedScheduleId}
            refreshListView={refreshListView}
            locationId={locationId}
            mode={FORM_ACTION.EDIT}
          />
        </Paper>
      )}
      {[FORM_ACTION.CREATE].includes(mode) && (
        <Paper variant="outlined" sx={{ mb: 2, mt: 2 }}>
          <DefaultScheduleForm
            params={commonParams}
            selectedScheduleId={selectedScheduleId}
            refreshListView={refreshListView}
            locationId={locationId}
            mode={FORM_ACTION.CREATE}
          />
        </Paper>
      )}
      {[FORM_ACTION.LIST].includes(mode) && (
        <Paper variant="outlined" sx={{ mb: 2, mt: 2 }}>
          <DefaultSchedulesList
            key={listRefreshKey}
            params={commonParams}
            selectedScheduleId={selectedScheduleId}
            refreshListView={refreshListView}
            locationId={locationId}
          />
        </Paper>
      )}
    </Box>
  );
}

export default DefaultSchedules;
